<template>
  <div>
 <div class="white-background list-top-margin">
   <!-- 面包屑导航 -->
   <div class="page-top">
     <el-breadcrumb separator-class="el-icon-arrow-right">
       <el-breadcrumb-item>基础数据</el-breadcrumb-item>
       <el-breadcrumb-item >
         <span @click="goBack" class="cursor-pointer">绩效工资配置</span>
       </el-breadcrumb-item>
       <el-breadcrumb-item>
         <span style="color:#000;font-weight:bold;">绩效工资匹配规则</span>
       </el-breadcrumb-item>
     </el-breadcrumb>
   </div>
   <div class="default-title defult-row-margin">绩效工资匹配规则</div>
   <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="执行中" name="first">
      <div class="small-title small-title-bold large-margin-bottom">绩效工资匹配规则执行中：您可以查看生效的绩效工资匹配规则，如需调整，请在草稿页签中修改。点击生效转成执行中规则。</div>
      <!--列表-->
      <el-table
          class="large-margin-bottom"
          size="mini"
          :data="listDataOne"

          v-loading="loading"
          border
          max-height="350px"
          stripe
          :header-cell-style="_headerStyle"
          element-loading-text="加载中"
          style="width: 600px;"
        >
          <el-table-column align="left" type="index" width="50" label="序号"></el-table-column>
          <el-table-column prop="deptNo" label="业务对象" ></el-table-column>
          <el-table-column prop="deptNo" label="属性" ></el-table-column>
      </el-table>
      <el-table
          size="mini"
          :data="listDataTwo"

          v-loading="loading"
          border
          max-height="350px"
          stripe
          :header-cell-style="_headerStyle"
          element-loading-text="加载中"
          style="width: 600px;"
        >
          <el-table-column align="left" type="index" width="75" label="优先级"></el-table-column>
          <el-table-column prop="deptNo" label="绩效维度组合" ></el-table-column>
      </el-table>
    </el-tab-pane>
    <el-tab-pane label="草稿" name="second">
      <div class="small-title small-title-bold large-margin-bottom">绩效工资匹配规则草稿：您可以修改系统内置的绩效工资匹配规则，生效后草稿规则将转成执行中</div>
      <div class="small-title">第一步：选择参与匹配绩效工资的业务对象的属性（最多20个）</div>
      <div class="default-top-bottom">
        <el-button size="small" type="primary" icon="el-icon-plus" @click="addOne">新增绩效工资取数维度</el-button>
      </div>
      <el-table
          size="mini"
          :data="listDataThree"

          v-loading="loading"
          border
          max-height="350px"
          stripe
          :header-cell-style="_headerStyle"
          element-loading-text="加载中"
          style="width: 600px;"
        >
          <el-table-column align="left" type="index" width="50" label="序号"></el-table-column>
          <el-table-column prop="businessObject" label="业务对象" ></el-table-column>
          <el-table-column prop="businessAttribute" label="属性" ></el-table-column>
          <el-table-column align="left" label="操作" width="90">
            <template slot-scope="scope">
              <el-button  @click="deleteThree(scope.$index, scope.row)" type="text" size="mini">删除</el-button>
            </template>
          </el-table-column>
      </el-table>
      <div class="small-title user-search">第二步：设定多业务对象属性组合的优先级（最多20级）</div>
      <div class="default-top-bottom">
        <el-button size="small" type="primary" icon="el-icon-plus" @click="addTwo">新增绩效工资维度组合</el-button>
      </div>
      <el-table
          size="mini"
          :data="listDataFour"

          v-loading="loading"
          border
          max-height="350px"
          stripe
          :header-cell-style="_headerStyle"
          element-loading-text="加载中"
          style="width: 600px;"
        >
          <el-table-column align="left" type="index" width="75" label="优先级"></el-table-column>
          <el-table-column prop="makeUp" label="绩效维度组合" ></el-table-column>
          <el-table-column align="left" label="操作" width="190">
            <template slot-scope="scope">
              <el-button  @click="upMove(scope.$index, scope.row)" type="text" size="mini">上移</el-button>
              <el-button  @click="downMove(scope.$index, scope.row)" type="text" size="mini">下移</el-button>
              <el-button  @click="edit(scope.$index, scope.row)" type="text" size="mini">编辑</el-button>
              <el-button  @click="deleteFour(scope.$index, scope.row)" type="text" size="mini">删除</el-button>
            </template>
          </el-table-column>
      </el-table>
      <div class="small-title user-search">第三步：草稿方案生效前，如果第一步的业务对象属性有增/删/移动操作，生效将清除现有的工价数据。建议备份后再点击生效（路径：绩效工资配置 > 导出数据）如果第一步的业务对象属性没有变化，现有的工价数据仍然可以使用，只是匹配的优先级有所调整</div>
      <div class="text-align-center default-top-bottom">
        <el-button size="small" type="primary"  @click="save">保存</el-button>
        <el-button size="small" type="primary" plain @click="todo">生效</el-button>
        <el-button size="small" type="default"  @click="cancel">取消</el-button>
      </div>
    </el-tab-pane>
  </el-tabs>
  <el-dialog title="添加绩效工资取数维度" :visible.sync="modeOneShow" width="500px" @close="closeOne" :close-on-click-modal="false">
    <AccessDimension v-if="modeOneShow" @done="closeOne"></AccessDimension>
  </el-dialog>
  <el-dialog title="新增绩效工资维度组合" :visible.sync="modeTwoShow" width="600px" @close="closeTwo" :close-on-click-modal="false">
    <DimensionCombination v-if="modeTwoShow" @done="closeTwo" :listDataThree="listDataThree"></DimensionCombination>
  </el-dialog>
 </div>
</div>
</template>
<script>
import Pagination from "@/components/Pagination";
import AccessDimension from '@/views/basicData/performAllocation/AccessDimension';
import DimensionCombination from '@/views/basicData/performAllocation/DimensionCombination';

export default {
name:'ImportLog',
components:{
   Pagination,
   AccessDimension,
   DimensionCombination,
},
data() {
 return {
   listDataOne: [{deptNo:'111'}],
   listDataTwo: [{deptNo:'111'}],
   listDataThree: [{
    businessObject:'指南',
    businessAttribute:'设计原则',
   },{
    businessObject:'指南复制',
    businessAttribute:'设计原则复制',
   }],
   listDataFour: [],
   loading: false,
   activeName:'first',
   modeOneShow:false,
   modeTwoShow:false,
 };
},
created() {},
methods: {
  upMove() {
  },
  downMove() {
  },
  edit() {
  },
  deleteThree(index,row) {
    this.$confirm('确认删除属性？操作将同时删除关联的绩效维度组合', '信息', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      this.listDataFour.map(function(item2,index2){
        if(item2.makeUp.indexOf(row.businessAttribute)!=-1){
          this.listDataFour.splice(index2,1)
        }
      }.bind(this))
      this.listDataThree.splice(index,1)
    })
    .catch(() => {
    })
  },
  deleteFour(index) {
    this.$confirm('确认删除绩效维度组合？', '信息', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      this.listDataFour.splice(index,1)
    })
    .catch(() => {
    })
  },
  save() {},
  todo() {
    this.$confirm('生效动作将清空当前绩效工价表，确认后将导出当前配置，操作后将无法撤回', '确定生效', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {

    })
    .catch(() => {
    })
  },
  cancel() {},
  /**
    * 返回上一级
    */
  goBack(){
    this.$emit("goBack");
  },
  handleClick(){

  },
  addOne(){
    if(this.listDataThree.length < 20){
      this.modeOneShow = true
    }else{
      this.$message.warning('最多选择参与匹配绩效工资的业务对象的属性(20个)')
    }
  },
  addTwo(){
    if(this.listDataFour.length < 20){
      this.modeTwoShow = true
    }else{
      this.$message.warning('最多设定多业务对象属性组合的优先级（20级）')
    }
  },
  closeOne(options){
    if(options && options.type == 'save'){
      var temp = options.data.routingNo
      var obj = {
        businessObject:temp[0],
        businessAttribute:temp[1],
      }
      this.listDataThree.push(obj)
    }
    this.modeOneShow = false
  },
  closeTwo(options){
    if(options && options.type == 'save'){
      var temp = options.data
      var arr = []
      temp.map(function(item){
        var tem = item.businessObject + '.' +  item.businessAttribute
        arr.push(tem)
      }.bind(this))
      var obj = {
        makeUp:arr.join('，')
      }
      this.listDataFour.push(obj)
    }
    this.modeTwoShow = false
  },
}
}
</script>
<style scoped>
 .page-top {
  height: 30px;
  line-height: 30px;
  }
  .small-title{
    font-size: 12px;
  }
  .small-title-bold{
    font-weight: bold;
  }

</style>



// WEBPACK FOOTER //
// src/views/basicData/performAllocation/MatchingRules.vue